import React from 'react';
import {withRouter} from "react-router-dom";
import ReactGA from 'react-ga';
import { connect } from 'react-redux';
import { langActions, pageActions, SamplesActions } from './../../actions';
import Headroom from 'react-headroom';
import OutsideClickHandler from 'react-outside-click-handler';

import DesktopHeader from './desktopHeader';
import MobileHeader from './mobileHeader';
import AddToSample from './../addToSample';

class Header extends React.Component {

    trackPagePreview = () => {
        const history = this.props;
        //defualt state for refresh or if visited from another website
        ReactGA.set({ page: history.location.pathname }); // Update the user's current page
        ReactGA.pageview(history.location.pathname); // Record a pageview for the given page
        this.unlisten = this.props.history.listen(location => {
            ReactGA.set({ page: location.pathname }); // Update the user's current page
            ReactGA.pageview(location.pathname); // Record a pageview for the given page
        });
    }

    addLangOnReload = () => {
        const {pathname} =  this.props.location;

        let lang = '';
        if (pathname.indexOf('/fr')>-1) {
            lang = 'fr';
        }

        this.props.updateLang(lang);
    }

    addPageName = () => {
        const {location: {pathname}} = this.props;
        this.setpage(pathname);
        this.unlisten2 = this.props.history.listen(({pathname}) => {
            this.setpage(pathname);
        });
    }

    setpage = (pathname) => {
        this.props.updatePage(pathname);
        document.body.setAttribute("page", pathname.split('/').join('-'));
    }


    componentDidMount(){
        this.trackPagePreview();
        this.addLangOnReload();
        this.addPageName();
      }
    
    componentWillUnmount(){
        this.unlisten();
        this.unlisten2();
    }

    render (){
        return (
            <OutsideClickHandler onOutsideClick= {()=>this.props.openSamples(false)}>
            <header>
                <MobileHeader/>
                <Headroom>
                    <DesktopHeader/>
                    <AddToSample/>
                </Headroom>
            </header>      
            </OutsideClickHandler>      
        );
    }
}


// what props do i need to get from the state for this component?
const mapStateToProps = (state) => {
    // get the props needed for this component from the state of the store.
    return {
        samplesopened: (state.samples && state.samples.opened),
    }
}

// what events will occur that will change the state in this component
const mapDispatchToProps = (dispatch) => {
    return {
        updateLang: (lang) => dispatch(langActions.update(lang)),
        updatePage: (pathname) => dispatch(pageActions.update(pathname)),
        openSamples: (isOpened) => dispatch(SamplesActions.open(isOpened))
    };
};

export default withRouter( connect(mapStateToProps, mapDispatchToProps)(Header) );

